import { render, staticRenderFns } from "./indexExamenes.vue?vue&type=template&id=4aec27f8&"
import script from "./indexExamenes.vue?vue&type=script&lang=js&"
export * from "./indexExamenes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports